import { render, staticRenderFns } from "./ExtendedRouterView.vue?vue&type=template&id=a8b948a4&scoped=true&"
import script from "./ExtendedRouterView.vue?vue&type=script&lang=ts&"
export * from "./ExtendedRouterView.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedRouterView.vue?vue&type=style&index=0&id=a8b948a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b948a4",
  null
  
)

export default component.exports